import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import { isMobile, isTablet } from 'react-device-detect';
import { FaList, FaHome } from 'react-icons/fa';
import MenusCatalog from './MenusCatalog';
import { useNavigate } from 'react-router-dom';

export default function MenusPage() {
    const isSmall = isMobile || isTablet;
    const navigate = useNavigate();

    return (
        <div className="panel-sigma-layout">
            <aside className={`panel-sigma-sidebar ${isSmall ? 'panel-sigma-sidebar-responsive' : ''}`}>
                {!isSmall && (
                    <div className="panel-sigma-avatar">
                        <FaList size={48} />
                    </div>
                )}
                <nav className="panel-sigma-nav">
                    <button title="Inicio" onClick={() => navigate('/menu/roles')}>
                        <FaHome />
                    </button>
                    {/* Botón para volver al catálogo de módulos */}
                    <button title="Módulos" onClick={() => navigate('/modulos')}>
                        <FaList />
                    </button>
                </nav>
            </aside>

            <MenusCatalog />
        </div>
    );
}
